import React, { FC } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FamilyCrestColor } from '@app/react/api';
import { ASSETS_PATH } from '@app/react/const/variables';
import { useMediaContext } from '@app/react/contexts/useMediaContext';
import { ZoomButton } from './ProductThumbnailZoomButton';

export type OnSelectFamilyCrestColor = (
    event: React.ChangeEvent<HTMLInputElement>,
    product: FamilyCrestColor
) => void;

export interface ProductThumbnailColorProps {
    product: FamilyCrestColor;
    checked: boolean;
    groupName: string;
    onClick: OnSelectFamilyCrestColor;
    onZoom?: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        product: FamilyCrestColor,
    ) => void;
}

export const ProductThumbnailColor4Desktop: FC<ProductThumbnailColorProps> = (
    props,
) => {
    const {
        product, checked, groupName, onClick, onZoom,
    } = props;

    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
        <li className="product-thumbnail item">
            <label className={classNames('body', { selected: checked })}>
                <input
                    type="radio"
                    name={groupName}
                    onChange={(ev) => onClick(ev, product)}
                    checked={checked}
                />
                <div className="product-thumbnail__thumbnail">
                    <img
                        src={product.productImage}
                        alt={product.name}
                    />
                </div>
                <div className="product-thumbnail__name">
                    インクの色：
                    {product.name}
                </div>
                <div className="product-thumbnail__icon-selected">
                    <img
                        src={`${ASSETS_PATH}/img/common/icon-selected.svg`}
                        alt="選択中"
                    />
                </div>
                <ZoomButton onClick={(ev) => { onZoom?.(ev, product); }} />
            </label>
        </li>
    );
    /* eslint-enable jsx-a11y/label-has-associated-control */
};

export const ProductThumbnailColor4Mobile: FC<ProductThumbnailColorProps> = ({
    product, checked, groupName, onClick, onZoom,
}) => (
    /* eslint-disable jsx-a11y/label-has-associated-control */
    <li className="product-thumbnail item">
        <label className={classNames('body', { selected: checked })}>
            <input
                type="radio"
                name={groupName}
                onChange={(ev) => onClick(ev, product)}
                checked={checked}
            />
            <div className="product-thumbnail__thumbnail">
                <img
                    src={product.productImage}
                    alt={product.name}
                />
            </div>
            <button type="button" className="footer" onClick={(ev) => { onZoom?.(ev, product); }}>
                <div className="product-thumbnail__name">
                    インクの色：
                    {product.name}
                </div>
                <FontAwesomeIcon
                    className="product-thumbnail__icon-zoom"
                    icon={faEllipsisV}
                    color="#676767"
                />
            </button>
            <div className="product-thumbnail__icon-selected">
                <img
                    src={`${ASSETS_PATH}/img/common/icon-selected.svg`}
                    alt="選択中"
                />
            </div>
        </label>
    </li>
);
/* eslint-enable jsx-a11y/label-has-associated-control */

export const ProductThumbnailColor: FC<ProductThumbnailColorProps> = (props) => {
    const { desktop } = useMediaContext();

    if (desktop) {
        return (<ProductThumbnailColor4Desktop {...props} />);
    }

    return (<ProductThumbnailColor4Mobile {...props} />);
};
